const UNIVERSITY = {
  SET_UNIVERSITY_QUERY: 'SET_UNIVERSITY_QUERY',
  SET_FACULTY_QUERY: 'SET_FACULTY_QUERY',
  SET_DEPARTMENT_QUERY: 'SET_DEPARTMENT_QUERY',
  SET_CLASSES_QUERY: 'SET_CLASSES_QUERY',

};

export default UNIVERSITY;
